'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS = exports.SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS = 30 * 60 * 1000;